import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Response } from '@app/core/model';
import { GoalStatistics } from '../../model/statistics.model';

@Injectable({
    providedIn: 'root',
})
export class GoalHttpService {
    private httpClient = inject(HttpClient);

    /**
     * Get Statistics
     */
    getStatistics(): Observable<GoalStatistics> {
        return this.httpClient.get<Response>('api/goal/profile/statistics').pipe(
            map((res: Response) => {
                return <GoalStatistics>res.data;
            }),
        );
    }
}
